<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <vue-google-autocomplete
        :id="name"
        :ref="name"
        :classname="form && form.errors.has(errorId) ? 'form-control is-invalid' : 'form-control'"
        :enable-geolocation="true"
        :fields="['address_components', 'formatted_address', 'geometry', 'type']"
        :value="value"
        country="au"
        placeholder=""
        @placechanged="getAddressData"
        @focus.native="$event.target.select()"
        @input.native="$emit('input', $event)"
      >
      </vue-google-autocomplete>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
// eslint-disable-next-line
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import BaseComponent from "./BaseComponent.vue";

export default {
  components: {
    VueGoogleAutocomplete,
  },
  extends: BaseComponent,

  data() {
    return {
      address: null,
    };
  },

  methods: {
    setAddressValue(address) {
      // noinspection JSUnresolvedFunction
      this.$refs[this.name].update(address);
    },

    getAddressData(address, place) {
      if (this.$lodash.get(place, "types.0") === "route") {
        this.$emit("error", place);
      }

      let subpremise = "";
      if (this.$lodash.get(place, "address_components.0.types.0") === "subpremise") {
        subpremise = this.$lodash.get(place, "address_components.0.long_name");

        if (subpremise.length > 0) {
          subpremise = `${subpremise}/`;
        }
      }

      const streetNumber = address.street_number || "";

      this.address = {
        street: `${subpremise}${streetNumber} ${address.route}`.trim(),
        city: address.locality,
        state: address.administrative_area_level_1,
        postcode: address.postal_code,
        formatted: place.formatted_address,
        latitude: address.latitude,
        longitude: address.longitude,
      };

      this.$emit("input", this.address);
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }
    },
  },
};
</script>
